import React from "react";
import { Provider, connect } from "react-redux";

import AnalyticsRouter, { AnalyticsRouterProps } from "./analyticsRouter";
import createAnalyticsStore from "../../stores/analyticsStore";

import {
  fetchParticipationData,
  fetchOrganizationData,
  fetchLeaderboardData,
  fetchBonusesData,
  fetchTopWordsData,
} from "../../actions/actions";

function mapStateToProps(state: AnalyticsRouterProps) {
  return state;
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchParticipationData: () => {
      fetchParticipationData(dispatch);
    },
    fetchBonusesData: () => {
      fetchBonusesData(dispatch);
    },
    fetchTopWordsData: () => {
      fetchTopWordsData(dispatch);
    },
    fetchOrganizationData: () => {
      fetchOrganizationData(dispatch);
    },
    fetchLeaderboardData: (teamId) => {
      fetchLeaderboardData(dispatch, teamId);
    },
  };
};

const AnalyticsContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(AnalyticsRouter);

export default function ProviderStore(props) {
  const store = createAnalyticsStore(props);

  return (
    <Provider store={store}>
      <AnalyticsContainer />
    </Provider>
  );
}
